module.exports = __webpack_public_path__ + "img/0967fb571f37761ef488e9feec280c5.4f3ba3ce.jpg";